import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Nav } from 'react-bootstrap';

interface WizardNavItemProps {
  icon: IconProp;
  label: string;
  step: number;
  isHorizontal?: boolean;
  disabled?: boolean;

  /**
   * done é do wizard original horizontal (mantido por compatibilidade)
   * completed é o nosso "verde quando concluiu"
   */
  done?: boolean;
  completed?: boolean;
}

const WizardNavItem = ({
  icon,
  label,
  step,
  isHorizontal,
  disabled,
  done,
  completed
}: WizardNavItemProps) => {
  // ✅ cor verde sem depender de CSS do tema
  const completedStyle = completed ? { color: 'var(--phoenix-success)' } : undefined;

  return (
    <Nav.Item as="li" className="nav-item">
      <Nav.Link
        className={classNames({ 'wizard-step-completed': completed })}
        eventKey={step}
        disabled={disabled}
        onClick={(e) => {
          if (disabled) {
            e.preventDefault();
            e.stopPropagation();
          }
        }}
      >
        <div
          className={classNames('text-center d-inline-block', {
            'd-xl-flex align-items-center gap-3': isHorizontal
          })}
        >
          <span className="nav-item-circle-parent">
            <span
              className={classNames('nav-item-circle', {
                'wizard-step-completed-circle': completed
              })}
              // ✅ tenta colorir wrapper também (ajuda quando o tema força cor no container)
              style={completedStyle}
            >
              <FontAwesomeIcon
                icon={icon}
                className={classNames({ 'nav-item-icon': isHorizontal })}
                // ✅ garante o verde no próprio SVG
                style={completedStyle}
              />

              {/* mantém o comportamento original do wizard horizontal */}
              {isHorizontal && (
                <FontAwesomeIcon className="check-icon" icon={faCheck} />
              )}
            </span>
          </span>

          <span
            className={classNames('fs-9 text-center', {
              'd-none d-md-block mt-1': !isHorizontal,
              'nav-item-title fs-xl-8': isHorizontal
            })}
          >
            {label}
          </span>
        </div>
      </Nav.Link>
    </Nav.Item>
  );
};

export default WizardNavItem;